import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import styles from './AiChatAssistantMobile.module.scss';
import ActiveChatMobileSession from './ActiveChatMobileSession';
import { IconButton, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { HOME } from '../../../common/constants/routes';

const AiChatAssistantMobile = () => {
    const [currentConversationId, setCurrentConversationId] = useState(() => uuidv4());
    const navigate = useNavigate();

    const handleNewChat = () => {
        setCurrentConversationId(uuidv4());
    };

    const handleBack = () => {
        navigate(HOME);
    };

    return (
        <div className={styles.mobileContainer}>
            <header className={styles.header}>
                <IconButton onClick={handleBack} className={styles.actionButton}>
                    <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>

                <Typography className={styles.title}>InfluioGPT</Typography>

                <IconButton onClick={handleNewChat} className={styles.actionButton}>
                    <AddIcon />
                </IconButton>
            </header>

            <main className={styles.chatContent}>
                <ActiveChatMobileSession
                    key={currentConversationId}
                    conversationId={currentConversationId}
                />
            </main>
        </div>
    );
};

export default AiChatAssistantMobile;
